module.exports = __webpack_public_path__ + "img/fondo-banner-principal.5d5e2f66.svg";